<template>
  <div class="">
    <div class="card is-shadowless">
      <div class="card-header is-shadowless">
        <SideMenu></SideMenu>
      </div>
      <div class="card-content">
        <div id="login" class="columns is-centered is-variable is-gapless is-mobile is-multiline">
          <Credentials class="column is-four-fifths-mobile"/>
          <p class="mt-6 padding column is-four-fifths-mobile">
              First time readers: Enter your email address and the password that's contained in the book.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Credentials from '@/components/CredentialsForm.vue'
export default {
  name: 'Login',

  components: {
    Credentials
  },
  data () {
    return {
    }
  },
  computed: {
    isLoggedIn () {
      if (this.$store.state.user && this.$root.progress.episode !== 'load' && this.$root.progress.episode !== 0) {
        return true
      }
      return false
    }
  },
  watch: {
    isLoggedIn: function (to, from) {
      if (to) {
        this.$router.replace({
          name: 'Location',
          params: {
            episode: this.$root.progress.episode,
            chapter: this.$root.progress.chapter
          }
        })
      }
    }
  }

}
</script>

<style lang="css" scoped>
  ul, li{
    list-style:none;
  }
</style>
